export const pricePlanInfo = ({ pricePlan }) => pricePlan.plan;
export default {};
